module.exports = __webpack_public_path__ + "static/MapMediumBackground-2e7b8abf28c6d6a312fd73bc4ab4744b.svg";